export class ThreeDSecureInstanceMissingError extends Error {
  constructor() {
    super('3DS instance is missing.');
    this.name = 'ThreeDSecureInstanceMissingError';
  }
}
